import IframeModal from "../components/IframeModal.js";
import { getReeltrixGames, reeltrixInitGame } from "../../js/api/reeltrix.js";
import { _t } from "../../services/TranslationService.js";

// Reeltrix Casino Games

const escapeHtml = (value) => String(value ?? "")
  .replace(/&/g, "&amp;")
  .replace(/</g, "&lt;")
  .replace(/>/g, "&gt;")
  .replace(/"/g, "&quot;");

let Reeltrix = {
  render: async () => {
    if (localStorage.getItem("reeltrixEnabled") != "1") {
      alert(_t(`Nuk keni qasje ne lojet e Casino!`));
      location.href = "#/";
      return "";
    }

    const providers = (await getReeltrixGames()) || [];

    let groupView = `
      <div class="searchGameHolder">
          <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20"><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5s4.
    5 2.01 4.5 4.5S11.99 14 9.5 14z"/></svg>
          <input type="search" id="searchGameInput" placeholder="${_t('Search game')}..." />
      </div>
    `;
    let groupBtnView = `<div class="groupFamilyBtn" data-btn-target="all"><span class="">${_t('All games')}</span></div>`;

    providers.forEach((item, index) => {
      if (!item.provider || !item.games || !item.games.length) return;

      // Groups are keyed by provider id, names like "Play'n GO" break the selectors
      const group = `provider-${item.provider.id}`;
      const isActive = index === 0;

      groupBtnView += `<div class="groupFamilyBtn ${isActive ? 'active' : ''}" data-btn-target="${group}"><span class="">${escapeHtml(item.provider.name)}</span></div>`;

      for (const element of item.games) {
        if (element.enabled === false) continue;
        groupView += `
          <div class="game animation-element" game="${escapeHtml(element.id)}" group="${group}" ${isActive ? '' : 'style="display: none;"'}>
            <img src="${escapeHtml(element.image)}" loading="lazy" onerror="javascript:this.src='./img/games_icons/duser.jpg'" />
            <span>${escapeHtml(element.name)}</span>
          </div>`;
      }
    });

    let view = /*html*/ `
       <style>
          /* Reeltrix images are square, the default desktop tile crops them to 80px */
          .reeltrixView.slotsMainWrapper #main .game img { height: auto; aspect-ratio: 1 / 1; }
          /* Provider tabs follow the site theme color instead of the bar.png background */
          .reeltrixCats.slotsCatHolder { background-image: none; background-color: var(--TitleBackColor, #14805e); border-bottom-color: var(--TitleBackBorderColor, #4acfa5); }
          .reeltrixCats .groupFamilyBtn.active { color: var(--InPlayColor, #ffdf1b); box-shadow: inset 0 -3px 0 var(--InPlayColor, #ffdf1b); }
       </style>
       <h1 class="deluxeTitle">Welcome To Casino VIP</h1>

       <div class="slotsCatHolder reeltrixCats">
            <div class="slotsCatHelper" id="slotsCatBtn" style="display: flex;">
              ${groupBtnView}
            </div>
       </div>
       <div class="slotsMainWrapper deluxeView reeltrixView">
          <div id="main" style="text-align: left;">
              ${providers.length ? groupView : `<p>${_t('No games found')}</p>`}
          </div>
       </div>
       `;
    return view;
  },
  after_render: async () => {
    if (localStorage.getItem("reeltrixEnabled") != "1") return;

    // Other casino pages leave bg-black on the body, Reeltrix uses the normal theme
    $("body").removeClass("bg-black");

    let catLengthWidth = 0;
    $(".groupFamilyBtn ").each(function (e) {
      catLengthWidth += $(this).outerWidth();
    });
    $("body .slotsCatHelper").css({
      width: catLengthWidth + 3 + "px",
    });

    // Filter games by provider
    $(".groupFamilyBtn").on("click", function (e) {
      let eventTarget = $(e.currentTarget).attr("data-btn-target");
      $("body .groupFamilyBtn").removeClass("active");
      $(e.currentTarget).addClass("active");
      $("#searchGameInput").val("");
      if (eventTarget === 'all') {
        $('.game').show();
      } else {
        $(".game[group='" + eventTarget + "']").show();
        $(".game").not("[group='" + eventTarget + "']").hide();
      }
    });

    // Search games
    $("#searchGameInput").unbind().on("keyup search", function (e) {
      let value = $(e.currentTarget).val().toLowerCase();
      $("body .groupFamilyBtn").removeClass("active");
      $("body .groupFamilyBtn[data-btn-target='all']").addClass("active");
      if (!value) {
        $('.game').show();
        return;
      }
      $(".game").filter(function () {
        $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
      });
    });

    $(".game").on("click", async function (e) {
      if (
        !localStorage.getItem("access_token") ||
        localStorage.getItem("access_token") == ""
      ) {
        alert("Login!");
        return;
      }

      if (localStorage.getItem("reeltrixEnabled") != "1") {
        alert("Nuk keni qasje ne lojet e Casino!");
        return;
      }

      const target = $(e.currentTarget);
      if (target.hasClass("clicked")) return;

      const gameId = target.attr("game");
      const gameName = target.children("span").text();
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

      target.addClass("clicked");
      const response = await reeltrixInitGame(gameId, isMobile ? "mobile" : "desktop");
      target.removeClass("clicked");

      const gameLink = response && response.success && response.url;
      if (!gameLink) {
        alert(_t("Loja nuk mund te hapet, provoni perseri!"));
        return;
      }

      IframeModal.loadIframe(gameLink, true);
      IframeModal.show(gameName);
    });
  },
};

export default Reeltrix;
